/**
 * 특수 블록 레지스트리 — 모든 특수 블록의 정의
 *
 * 새 블록 추가 시 여기에만 등록하면 picker + editor_core에 자동 반영.
 * category: "common" (Note + Page) | "pageOnly" (Page 전용)
 */

export const SPECIAL_BLOCKS = {
  subscribe_form: {
    title: "구독 폼",
    description: "뉴스레터 구독 폼을 삽입합니다. 웹에서 아직 구독하지 않은 독자에게만 표시되며, 이메일에는 포함되지 않습니다",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" /><path d="M3 7l9 6l9 -6" /></svg>',
    category: "common",
  },
  membership_cta: {
    title: "유료 구독 안내",
    description: "유료 멤버십 가입 버튼을 삽입합니다. 이메일과 웹 모두 표시되며, 이미 유료 구독 중인 독자에게는 구독 중 안내로 대체됩니다",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z" /></svg>',
    category: "common",
  },
  post_embed: {
    title: "뉴스레터 임베드",
    description: "특정 뉴스레터를 카드로 삽입합니다",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" /><path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" /><path d="M3 6l0 13" /><path d="M12 6l0 13" /><path d="M21 6l0 13" /></svg>',
    category: "common",
  },
  recent_posts: {
    title: "최신 뉴스레터 목록",
    description: "최근 발행된 뉴스레터를 목록으로 표시합니다",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11" /><path d="M8 8l4 0" /><path d="M8 12l4 0" /><path d="M8 16l4 0" /></svg>',
    category: "pageOnly",
  },
};

/**
 * 컨텍스트에 맞는 블록 목록 반환
 * @param {Object} options - { includePageWidgets: boolean }
 */
export function getAvailableSpecialBlocks(options = {}) {
  const { includePageWidgets = false } = options;
  const available = {};
  Object.entries(SPECIAL_BLOCKS).forEach(([key, block]) => {
    if (block.category === "common" || (block.category === "pageOnly" && includePageWidgets)) {
      available[key] = block;
    }
  });
  return available;
}
